import React, { useState } from "react";
import { LoadingButton } from "@mui/lab";
import { Box, Button, Dialog, Typography } from "@mui/material";
import AlertMsg from "../component/AlertMsg";

function LogoutModal(props) {
	const { loading, open, setOpen, logoutApi, logoutMsg, setLogoutMsg } = props;
	const [confirmOpen, setConfirmOpen] = useState(false);

	const onConfirmHandle = async () => {
		await logoutApi();
		setConfirmOpen(true);
	};

	return (
		<>
			<Dialog open={open}>
				<Box
					display={"flex"}
					flexDirection={"column"}
					justifyContent={"space-between"}
					alignItems={"center"}
					width={300}
					height={150}
					p={2}>
					<Typography fontSize={18}>خروج</Typography>
					<Typography fontSize={16}>آیا از خروج اطمینان دارید؟</Typography>
					<Box display={"flex"} justifyContent={"space-evenly"} width={"100%"}>
						<Button
							variant="contained"
							sx={{ fontSize: "16px" }}
							onClick={() => {
								setOpen(false);
							}}>
							انصراف
						</Button>
						<LoadingButton
							variant="contained"
							color="secondary"
							onClick={onConfirmHandle}
							sx={{ fontSize: "16px", color: "white" }}
							loading={loading}>
							خروج
						</LoadingButton>
					</Box>
				</Box>
			</Dialog>

			<Dialog open={confirmOpen}>
				<Box
					display={"flex"}
					flexDirection={"column"}
					justifyContent={"space-between"}
					alignItems={"center"}
					width={300}
					height={150}
					p={2}>
					<Typography fontSize={18}>
						{logoutMsg &&
							(logoutMsg.type ? (
								<AlertMsg message={logoutMsg} type={"success"} />
							) : (
								<AlertMsg message={logoutMsg} type={"error"} />
							))}
					</Typography>
					{logoutMsg &&
						(logoutMsg.type ? null : (
							<Button
								variant="contained"
								color="error"
								sx={{ color: "white", fontSize: "15px", mt: 1 }}
								onClick={() => {
									setConfirmOpen(false);
									setOpen(false);
									setLogoutMsg(null);
								}}>
								متوجه شدم
							</Button>
						))}
				</Box>
			</Dialog>
		</>
	);
}

export default LogoutModal;
